import { render, staticRenderFns } from "./ColumnName.vue?vue&type=template&id=54955c26"
import script from "./ColumnName.vue?vue&type=script&lang=js"
export * from "./ColumnName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports